
import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Button } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";

import './BeforeFooter.scss'

const white = "#ffffff";
const offWhite = "rgba(255, 255, 255, 0.7)"

const useStyles = makeStyles(theme => ({
  beforeFooter: {
    backgroundColor: theme.palette.primary.main
  },
  white: {
    color: offWhite,
    border: `2px solid ${offWhite}`,
    '&:hover': {
      color: white,
      borderColor: white
    },
    '&:focus': {
      boxShadow: `0 0 5px 0px ${white}`,
      outline: 'none'
    }
  },
  action: {
    height: 36,
    fontSize: "0.875rem",
    fontWeight: 700,
    letterSpacing: "1.4px",
    color: theme.palette.primary.main,
    backgroundColor: white,
    boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
    '&:hover': {
      borderColor: offWhite
    },
    '&:focus': {
      backgroundColor: offWhite,
      outline: "none"
    }
  }
}));

export default function BeforeFooter(props) {
  const classes = useStyles();

  const action = props.action || null;
  const href = action ? undefined : (props.href || '#'); // href should be undefined if onclick action is defined
  const buttonLabel = props.buttonLabel || 'GET A QUOTE';

  return (
    <Row className={`${classes.beforeFooter} ${props.isModernized ? "modernized" : ""} before-footer`}>
      <Col lg>
        <Row className={`justify-content-center  ${props.isModernized ? "" : " pb-5"}`}>
          <h2 className="text-center">{props.title}</h2>
        </Row>
        <Row className="justify-content-center">
          <Button variant={`${props.isModernized ? "contained" : "outlined" }`} size="large" href={href} onClick={action} className={`btn-wide-sm  ${props.isModernized ? classes.action : classes.white}`}>{buttonLabel}</Button>
        </Row>
      </Col>
    </Row >
  );
}



// WEBPACK FOOTER //
// ./src/components/BeforeFooter/BeforeFooter.js